import { render, staticRenderFns } from "./ClientUserGroup.vue?vue&type=template&id=6fe513c4"
import script from "./ClientUserGroup.vue?vue&type=script&lang=js"
export * from "./ClientUserGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports